
import React, { useMemo } from 'react';
import ArrowDownwardIcon from '@mui/icons-material//ArrowDownward';
import ArrowForwardIcon from '@mui/icons-material//ArrowForward';
import ArrowUpwardIcon from '@mui/icons-material//ArrowUpward';
import { Box, Typography } from '@mui/material';
import { GROWTH_PERCENTAGE_PROPERTY, METRIC_NOT_AVAILABLE, VALUE_PROPERTY } from 'common/constants/dashboards';
import { MetricCardProps } from './MetricCard.props';
import { classes, StyledBox } from './MetricCard.styles';


const MetricCard = ({ title, value, format }: MetricCardProps) => {
  const growthData = useMemo(() => {
    const isUp = value.growth_percentage > 0;
    const isDown = value.growth_percentage < 0;

    let changeTextClass = 'neutral';
    if (isUp) {
      changeTextClass = 'up';
    } else if (isDown) {
      changeTextClass = 'down';
    }

    return {
      isUp,
      isDown,
      changeTextClass,
    };
  }, [value.growth_percentage]);

  const renderArrow = () => {
    if (growthData.isDown) {
      return <ArrowDownwardIcon className={`${classes.arrowIcon} down`} />;
    }
    if (growthData.isUp) {
      return <ArrowUpwardIcon className={`${classes.arrowIcon} up`} />;
    }
    return <ArrowForwardIcon className={`${classes.arrowIcon} neutral`} />;
  };

  const growthLabel = format === '%' ? ' points' : '%';

  const formatDisplay = (
    value: { value?: number | null; growth_percentage?: number | null },
    property: typeof VALUE_PROPERTY | typeof GROWTH_PERCENTAGE_PROPERTY,
    format: string
  ): string => {
    const val = value[property];
    if (val === undefined || val === null) {
      return METRIC_NOT_AVAILABLE;
    }

    return `${val.toFixed(2)}${format}`;
  };

  const displayValue = formatDisplay(value, VALUE_PROPERTY, format);
  const displayGrowthPercentage = formatDisplay(value, GROWTH_PERCENTAGE_PROPERTY, growthLabel);

  return (
    <StyledBox className={classes.cardContainer}>
      <Typography className={classes.subtitle}>Median</Typography>
      <Typography variant="body1" className={classes.title}>
        {title}
      </Typography>
      <Box className={classes.valueContainer}>
        <Typography className={classes.value}>{displayValue}</Typography>

        {value && (
          <Box className={classes.changeValueContainer}>
            {renderArrow()}
            <Typography className={`${classes.changeText} ${growthData.changeTextClass}`}>
              {displayGrowthPercentage} month over month
            </Typography>
          </Box>
        )}
      </Box>
    </StyledBox>
  );
};

export default MetricCard;
